import { useCallback, useMemo } from "react";
import { useRecoilValue } from "recoil";
import { locationsState } from "../../../../state/atoms";
import { locationLabel } from "./DataKitManageLocationsModal";

type HasLocation = { locationId?: number | null; locationName?: string | null };

/**
 * A menu's location as this account names it (Oct 13, QA: menus showed no location). Read from the
 * account's own locations - the list Location Assignments shows - by the design's location id;
 * shared's own label is only the fallback, since it reads the legacy location record, which newer
 * accounts don't always have.
 */
export function useMenuLocation() {
  const locations = useRecoilValue(locationsState);
  const byId = useMemo(() => {
    const map = new Map<number, string>();
    (locations || []).forEach((l) => {
      if (l.internalId != null) map.set(Number(l.internalId), locationLabel(l));
    });
    return map;
  }, [locations]);
  return useCallback(
    (menu: HasLocation): string | null =>
      (menu.locationId != null ? byId.get(Number(menu.locationId)) : undefined) || menu.locationName || null,
    [byId]
  );
}
